import { IAutomationObject } from '../../types'

export interface IShiftFunction2Point extends IAutomationObject {
    flowBase: number;
    flowMax: number;
    outTBase: number;
    outTMax: number;
    actSetpoint: number;

    onValueChanged: any;
}
export type  ILine = {
    lines: 
        {
            name: string,
            points:  IPoint[],
            key: any
        }[]
}
export type  IPoint = {
    x: number,
    y: number
}


export const schema = 'AutomationApps.Functions.SetPoints.ShiftFunction2Point';


    